import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import CompanyProfileSearchRequest from '@/models/Companies/CompanyProfileSearchRequest';
import CreateCompanyRequest from '@/models/Companies/CreateCompanyRequest';
import CompanyDto from '@/models/Companies/CompanyDto';
import { component } from 'vue/types/umd';

export interface ICompanyListState {
  companies: CompanyProfileDto[];
  newCompany: CompanyDto;
  loading: boolean;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'CompanyList', namespaced: true})
class CompanyList extends VuexModule implements ICompanyListState {
  
    public companies: CompanyProfileDto[] = [];  
    public newCompany: CompanyDto = null;
    public loading = true;
    public loadingDialog = false;


    @Action
    async createCompany(request: CreateCompanyRequest) {
        this.setLoadingDialog(true); 
        await ajax.post(`/api/v1/agency/companies`, request)
        .then(response => {
            this.context.commit("setNewCompany", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            this.context.commit("setNewCompany", null);
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        })
    }

    @Action
    async searchCompanies() {
        const request = new CompanyProfileSearchRequest();
        this.setLoading(true);
        await ajax.post(`/api/v1/agency/companies/search`, request)
        .then(response => {
            this.context.commit("setCompanies", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.companies = [];
        this.newCompany = null;
        this.loadingDialog = false;

    }

    @Mutation
    private async setLoading(isLoading: boolean) {
        this.loading = isLoading;
    }

    @Mutation
    private async setCompanies(companies: CompanyProfileDto[]) {
        this.companies = companies;
    }

    @Mutation
    private async setNewCompany(company: CompanyDto) {
        this.newCompany = company;
    }

    @Mutation
    private async setLoadingDialog(isLoadingDialog: boolean) {
        this.loadingDialog = isLoadingDialog;
    }
    }

    export const CompanyListModule = getModule(CompanyList)
